import { NoopComponent } from '@components/Noop';
import { isAnalyticsDisabled } from 'lib/global';
import { AnalyticsProvider as ActualProvider } from './AnalyticsProvider';

export * from './eventTypes';
export * from './useAnalytics';

export const AnalyticsProvider = isAnalyticsDisabled
    ? NoopComponent
    : ActualProvider;
